import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from './app/app.routes';
import { TranslateModule } from '@ngx-translate/core';
import { providerConfig } from './providerconfig';
import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BASE_PATH } from './app/core/swagger-api';
import {
  BASE_PATH as BASE_PATH_V1,
  Configuration,
  ConfigurationParameters
} from './app/core/swagger-api-v1';
import { environment } from './environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { inFlightDedupInterceptor } from './app/core/interceptors/in-flight-dedup.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { getTranslateModuleConfig } from '@cyan/utils';
import { jwtInterceptor } from './app/core/interceptors/jwt.interceptor';
import { errorPageInterceptor } from '@cyan/error-page';
import { AccountService } from 'services/account.service';
import { companyInterceptor } from './app/core/interceptors/company.interceptor';
import { timeoutInterceptor } from './app/core/interceptors/timeout.interceptor';
import { AppConfigService } from 'services/app-config.service';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { JWT_COOKIE_CONFIG, JwtCookieService } from '@cyan/jwt-cookie';

export function apiConfigurationFactory(): Configuration {
  const configurationParameters: ConfigurationParameters = {
    basePath: environment.basePath
  };

  return new Configuration(configurationParameters);
}

function appSetup$(): Observable<void> {
  inject(JwtCookieService).extractAndSaveJwtFromUrl();
  const appConfigService = inject(AppConfigService);
  const accountService = inject(AccountService);
  return appConfigService.init$().pipe(
    switchMap(() => {
      return appConfigService.appConfig.features.userRoles
        ? accountService.loadUserData$()
        : of(undefined);
    })
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: BASE_PATH, useValue: environment.basePath },
    { provide: BASE_PATH_V1, useValue: environment.basePath },
    {
      provide: JWT_COOKIE_CONFIG,
      useValue: { lifetimeHours: environment.jwtCookieLifetimeHours }
    },
    provideAppInitializer(() => appSetup$()),
    provideRouter(APP_ROUTES),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([
        inFlightDedupInterceptor,
        authInterceptor,
        jwtInterceptor,
        errorPageInterceptor,
        companyInterceptor,
        timeoutInterceptor
      ])
    ),
    importProvidersFrom([
      MatSnackBarModule,
      TranslateModule.forRoot(
        getTranslateModuleConfig(
          providerConfig.languages,
          providerConfig.defaultLanguage,
          environment.version
        )
      )
    ])
  ]
});
